<script setup>
import { onMounted, ref } from 'vue'
import logo from '../assets/logo.png'
import poster from '../assets/poster.webp'

const inviteCode = ref('')
const copied = ref(false)

const IOS_DOWNLOAD_URL = 'https://apps.apple.com/cn/app/id6748722166'
const ANDROID_DOWNLOAD_URL = 'https://files.wanyutec.com.cn/apk/bobobi-1.0.3.apk'

onMounted(() => {
  const params = new URLSearchParams(window.location.search)
  const code = params.get('code')
  if (code) {
    inviteCode.value = code
  }
})

async function copyCode() {
  if (!inviteCode.value) return
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(inviteCode.value)
    } else {
      const input = document.createElement('input')
      input.value = inviteCode.value
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
    }
    copied.value = true
    setTimeout(() => {
      copied.value = false
    }, 1500)
  } catch (e) {
    console.error('复制失败', e)
  }
}
</script>

<template>
  <div class="page">
    <div class="container">
      <div class="card">
        <img class="logo" :src="logo" alt="养只啵啵鼻" />

        <div class="invite-box">
          <div class="invite-title">邀请码</div>
          <div class="invite-row">
            <input
                v-model="inviteCode"
                class="invite-input"
                placeholder="例如：APEEKEJJHJML"
            />
            <button class="copy-btn" @click="copyCode">
              {{ copied ? '已复制' : '复制' }}
            </button>
          </div>
        </div>

        <img class="poster" :src="poster" alt="养只啵啵鼻海报" />

        <a class="btn ios" :href="IOS_DOWNLOAD_URL">iOS 下载</a>
        <a class="btn android" :href="ANDROID_DOWNLOAD_URL">安卓下载</a>
      </div>
    </div>
  </div>
</template>

<style scoped>
* {
  box-sizing: border-box;
}

.page {
  min-height: 100svh;
  background: #fff;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", sans-serif;
}

.container {
  max-width: 420px;
  margin: 0 auto;
  padding: 16px;
}

.card {
  background: rgba(255, 255, 255, 0.9);
  border-radius: 24px;
  padding: 16px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.1);
}

.logo {
  width: 120px;
  display: block;
}

.invite-box {
  margin-top: 12px;
  padding: 12px;
  border-radius: 16px;
  border: 1px dashed #ddd;
}

.invite-title {
  margin-bottom: 8px;
  font-weight: 600;
  color: #222;
}

.invite-row {
  display: flex;
  gap: 8px;
}

.invite-input {
  flex: 1;
  padding: 10px;
  border-radius: 12px;
  border: 1px solid #ccc;
  outline: none;
  font-size: 14px;
}

.copy-btn {
  padding: 10px 14px;
  border: none;
  border-radius: 12px;
  background: #ff8fb1;
  font-weight: 600;
  color: #111;
  cursor: pointer;
}

.poster {
  width: 100%;
  border-radius: 20px;
  margin-top: 16px;
  display: block;
}

.btn {
  display: block;
  text-align: center;
  padding: 14px;
  border-radius: 16px;
  margin-top: 12px;
  text-decoration: none;
  font-weight: 600;
}

.ios {
  background: #ff8fb1;
  color: #111;
}

.android {
  background: #eee;
  color: #111;
}
</style>
